import { render, staticRenderFns } from "./GrPublicFooter.vue?vue&type=template&id=4647a2fb&scoped=true&"
import script from "./GrPublicFooter.vue?vue&type=script&lang=ts&"
export * from "./GrPublicFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GrPublicFooter.vue?vue&type=style&index=0&id=4647a2fb&lang=scss&scoped=true&"
import style1 from "./GrPublicFooter.vue?vue&type=style&index=1&id=4647a2fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647a2fb",
  null
  
)

/* custom blocks */
import block0 from "./GrPublicFooter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Ccomponents%5CstartPageNew%5CGrPublicFooter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
